export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./worksContent.vue?vue&type=template&id=61694727&"


//////////////////
// WEBPACK FOOTER
// ./src/components/worksContent.vue?vue&type=template&id=61694727&
// module id = null
// module chunks = 